export default {
  'error.title': 'เกิดปัญหากับระบบ',
  'error.description':
    'กรุณาลองรีเฟรชหน้าจอหรือลองเปิดหน้าใหม่อีกครั้ง<br />หากปัญหายังไม่หาย โปรดติดต่อพนักงานที่สาขาเพื่อขอความช่วยเหลือ',
} as Record<string, string>;
